// 預設鼓點模式配置
export const PRESET_DRUM_PATTERNS = {
  // === 搖滾類型 ===
  rock: {
    key: "rock",
    nameKey: "drumPatterns.rock", 
    description: "Classic rock beat",
    recommendedDrumKit: "rock",
    timeSignature: "4/4",
    noteDivision: "16n",
    tempo: 120,
    patterns: {
      "BD": [1, 0, 0, 0, 1, 0, 0, 0, 1, 0, 0, 0, 1, 0, 0, 0], // Kick on 1, 5, 9, 13
      "SD": [0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0], // Snare on 5, 13
      "CH": [1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0], // Hi-hat on 8ths
      "OH": [0, 0, 0, 1, 0, 0, 0, 1, 0, 0, 0, 1, 0, 0, 0, 1], // Open hat accents
    }
  },
  rockBallad: {
    key: "rockBallad",
    nameKey: "drumPatterns.rockBallad",
    description: "Slow rock ballad beat",
    recommendedDrumKit: "rock",
    timeSignature: "4/4",
    noteDivision: "8n",
    tempo: 80,
    patterns: {
      "BD": [1, 0, 0, 0, 1, 0, 0, 0], // Simple kick pattern
      "SD": [0, 0, 1, 0, 0, 0, 1, 0], // Backbeat snare
      "CH": [1, 1, 1, 1, 1, 1, 1, 1], // Steady hi-hat
      "CR": [1, 0, 0, 0, 0, 0, 0, 0], // Crash on 1
    }
  },
  rockShuffle: {
    key: "rockShuffle",
    nameKey: "drumPatterns.rockShuffle",
    description: "Rock shuffle groove",
    recommendedDrumKit: "rock",
    timeSignature: "4/4", 
    noteDivision: "8n",
    tempo: 110,
    patterns: {
      "BD": [1, 0, 0, 1, 0, 0, 1, 0], // Shuffle kick
      "SD": [0, 0, 1, 0, 0, 0, 1, 0], // Backbeat
      "CH": [1, 0, 1, 1, 0, 1, 1, 0], // Shuffle hi-hat
    }
  },
  breakbeat: {
    key: "breakbeat",
    nameKey: "drumPatterns.breakbeat",
    description: "Classic breakbeat pattern", 
    recommendedDrumKit: "breakbeat",
    timeSignature: "4/4",
    noteDivision: "16n",
    tempo: 130,
    patterns: {
      "BD": [1, 0, 0, 0, 0, 0, 1, 0, 0, 1, 0, 0, 0, 0, 0, 0], // Amen break style kick
      "SD": [0, 0, 0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 1, 0, 1, 0], // Complex snare pattern
      "CH": [1, 1, 0, 1, 0, 1, 1, 0, 1, 0, 1, 1, 0, 1, 0, 1], // Breakbeat hi-hat
      "CP": [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0], // Sparse clap
    }
  },

  // === 電子類型 ===
  disco: {
    key: "disco",
    nameKey: "drumPatterns.disco",
    description: "Four-on-the-floor disco",
    recommendedDrumKit: "disco",
    timeSignature: "4/4",
    noteDivision: "16n", 
    tempo: 125,
    patterns: {
      "BD": [1, 0, 0, 0, 1, 0, 0, 0, 1, 0, 0, 0, 1, 0, 0, 0], // Four on the floor
      "SD": [0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0], // Backbeat
      "CH": [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1], // 16th note hi-hat
      "OH": [0, 0, 1, 0, 0, 0, 1, 0, 0, 0, 1, 0, 0, 0, 1, 0], // Open hat accents
      "CP": [0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 1], // Clap on off-beats
    }
  },
  house: {
    key: "house",
    nameKey: "drumPatterns.house",
    description: "Classic house beat",
    recommendedDrumKit: "electronic",
    timeSignature: "4/4",
    noteDivision: "16n",
    tempo: 128,
    patterns: {
      "BD": [1, 0, 0, 0, 1, 0, 0, 0, 1, 0, 0, 0, 1, 0, 0, 0], // Four on the floor
      "SD": [0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0], // Simple backbeat
      "CH": [0, 0, 1, 0, 0, 0, 1, 0, 0, 0, 1, 0, 0, 0, 1, 0], // Off-beat hi-hat
      "OH": [1, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0], // Open hat on 1 and 9
    }
  },
  techno: {
    key: "techno",
    nameKey: "drumPatterns.techno",
    description: "Driving techno pattern",
    recommendedDrumKit: "electronic",
    timeSignature: "4/4",
    noteDivision: "16n",
    tempo: 135,
    patterns: {
      "BD": [1, 0, 0, 0, 1, 0, 0, 0, 1, 0, 0, 0, 1, 0, 0, 0], // Four on the floor
      "SD": [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0], // Minimal snare
      "CH": [0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1], // 16th off-beat
      "CP": [0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0], // Clap backbeat
    }
  },

  // === 爵士類型 ===
  jazz: {
    key: "jazz",
    nameKey: "drumPatterns.jazz",
    description: "Swing jazz pattern",
    recommendedDrumKit: "jazz",
    timeSignature: "4/4",
    noteDivision: "8n",
    tempo: 140,
    patterns: {
      "BD": [1, 0, 0, 0, 1, 0, 0, 0], // Simple kick pattern
      "SD": [0, 0, 1, 0, 0, 0, 1, 0], // Backbeat snare
      "CH": [1, 1, 1, 1, 1, 1, 1, 1], // Swing hi-hat (8th notes)
      "RD": [1, 0, 1, 1, 1, 0, 1, 1], // Jazz ride pattern
    }
  },
  jazzWaltz: {
    key: "jazzWaltz",
    nameKey: "drumPatterns.jazzWaltz",
    description: "Jazz waltz in 3/4",
    recommendedDrumKit: "jazz",
    timeSignature: "3/4",
    noteDivision: "8n",
    tempo: 160,
    patterns: {
      "BD": [1, 0, 0, 0, 0, 0], // Kick on 1
      "SD": [0, 0, 1, 0, 0, 1], // Snare on 3 and 6
      "RD": [1, 1, 1, 1, 1, 1], // Steady ride
      "CH": [0, 0, 0, 1, 0, 0], // Hi-hat foot on 4
    }
  },
  bossa: {
    key: "bossa",
    nameKey: "drumPatterns.bossa",
    description: "Bossa nova groove",
    recommendedDrumKit: "jazz",
    timeSignature: "4/4",
    noteDivision: "8n",
    tempo: 120,
    patterns: {
      "BD": [1, 0, 0, 1, 0, 0, 1, 0], // Bossa kick
      "SD": [0, 0, 1, 0, 0, 1, 0, 0], // Subtle snare
      "CH": [1, 0, 1, 0, 1, 0, 1, 0], // Soft hi-hat
      "RD": [1, 1, 0, 1, 1, 0, 1, 1], // Bossa ride
    }
  },

  // === 放克類型 ===
  funk: {
    key: "funk",
    nameKey: "drumPatterns.funk",
    description: "Groovy funk pattern",
    recommendedDrumKit: "funk",
    timeSignature: "4/4", 
    noteDivision: "16n",
    tempo: 100,
    patterns: {
      "BD": [1, 0, 0, 1, 0, 0, 1, 0, 0, 0, 1, 0, 0, 0, 0, 0], // Syncopated kick
      "SD": [0, 0, 0, 0, 1, 0, 1, 0, 0, 0, 0, 0, 1, 0, 0, 0], // Funky snare
      "CH": [1, 0, 1, 1, 0, 1, 0, 1, 1, 0, 1, 1, 0, 1, 0, 1], // Complex hi-hat
      "CP": [0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 1], // Clap accents
    }
  },
  funkGhost: {
    key: "funkGhost",
    nameKey: "drumPatterns.funkGhost",
    description: "Funk with ghost notes",
    recommendedDrumKit: "funk",
    timeSignature: "4/4",
    noteDivision: "16n",
    tempo: 95,
    patterns: {
      "BD": [1, 0, 0, 0, 0, 0, 1, 0, 0, 1, 0, 0, 0, 0, 0, 0], // Funk kick
      "SD": [0, 1, 0, 1, 1, 0, 0, 1, 0, 1, 0, 1, 1, 0, 0, 1], // Ghost notes
      "CH": [1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0], // Steady hi-hat
    }
  },
  neosoul: {
    key: "neosoul",
    nameKey: "drumPatterns.neosoul",
    description: "Neo-soul groove",
    recommendedDrumKit: "funk",
    timeSignature: "4/4",
    noteDivision: "16n",
    tempo: 90,
    patterns: {
      "BD": [1, 0, 0, 0, 0, 0, 0, 1, 0, 0, 1, 0, 0, 0, 0, 0], // Neo-soul kick
      "SD": [0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 1, 0, 1, 0], // Laid back snare
      "CH": [1, 0, 1, 1, 0, 1, 1, 0, 1, 1, 0, 1, 0, 1, 0, 1], // Complex hi-hat
      "RD": [0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0], // Sparse ride
    }
  },

  // === 世界音樂類型 ===
  latin: {
    key: "latin",
    nameKey: "drumPatterns.latin", 
    description: "Latin percussion groove",
    recommendedDrumKit: "latin",
    timeSignature: "4/4",
    noteDivision: "16n",
    tempo: 110,
    patterns: {
      "BD": [1, 0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, 0], // Clave-inspired kick
      "SD": [0, 0, 1, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 1, 0, 0], // Cross-stick snare
      "CH": [1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0], // Steady 8th hi-hat
      "CP": [0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 1], // Clap accents
      "CB": [1, 0, 0, 1, 0, 1, 0, 0, 1, 0, 0, 1, 0, 1, 0, 0], // Cowbell pattern
      "SH": [0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1], // Shaker 16ths
    }
  },
  salsa: {
    key: "salsa",
    nameKey: "drumPatterns.salsa",
    description: "Salsa rhythm",
    recommendedDrumKit: "latin",
    timeSignature: "4/4",
    noteDivision: "8n",
    tempo: 180,
    patterns: {
      "BD": [1, 0, 0, 1, 0, 0, 1, 0], // Salsa kick
      "SD": [0, 0, 1, 0, 0, 1, 0, 0], // Timbales
      "CB": [1, 0, 1, 1, 0, 1, 1, 0], // Cowbell clave
      "SH": [1, 1, 1, 1, 1, 1, 1, 1], // Maracas
    }
  },
  samba: {
    key: "samba",
    nameKey: "drumPatterns.samba",
    description: "Brazilian samba",
    recommendedDrumKit: "latin",
    timeSignature: "4/4",
    noteDivision: "16n",
    tempo: 120,
    patterns: {
      "BD": [1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0], // Surdo pattern
      "SD": [0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1], // Caixa
      "SH": [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1], // Constant shaker
      "AG": [1, 0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, 0], // Agogo bells
    }
  },
  chillhopGroove1: {
    key: "chillhopGroove1",
    nameKey: "drumPatterns.chillhopGroove1",
    description: "Mellow lo-fi groove",
    recommendedDrumKit: "chillhop",
    timeSignature: "4/4",
    noteDivision: "16n",
    tempo: 72,
    patterns: {
      "BD": [1, 0, 0, 0, 0, 0, 1, 0, 0, 1, 0, 0, 0, 0, 0, 0],
      "SD": [0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0],
      "CH": [1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0],
      "OH": [0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 1],
      "CP": [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0],
      "CR": [1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
    }
  },
  chillhopGroove2: {
    key: "chillhopGroove2",
    nameKey: "drumPatterns.chillhopGroove2",
    description: "Sidechained lo-fi feel",
    recommendedDrumKit: "chillhop",
    timeSignature: "4/4",
    noteDivision: "16n",
    tempo: 68,
    patterns: {
      "BD": [1, 0, 0, 0, 1, 0, 0, 0, 1, 0, 0, 0, 1, 0, 0, 0],
      "SD": [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      "CH": [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
      "OH": [0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0],
      "CP": [0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0]
    }
  },
  chillhopGroove3: {
    key: "chillhopGroove3",
    nameKey: "drumPatterns.chillhopGroove3",
    description: "Lo-fi with ghost snares",
    recommendedDrumKit: "chillhop",
    timeSignature: "4/4",
    noteDivision: "16n",
    tempo: 78,
    patterns: {
      "BD": [1, 0, 0, 0, 0, 0, 1, 0, 0, 1, 0, 0, 0, 0, 0, 0],
      "SD": [0, 1, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 1, 0, 0, 0],
      "CH": [1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0],
      "CP": [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0]
    }
  },

  // === 新增的pattern ===
  trap: {
    key: "trap",
    nameKey: "drumPatterns.trap",
    description: "Modern trap beat",
    recommendedDrumKit: "electronic",
    timeSignature: "4/4",
    noteDivision: "16n",
    tempo: 140,
    patterns: {
      "BD": [1, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 1, 0, 0, 0], // Trap kick pattern
      "SD": [0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0], // Snare on 2 and 4
      "CH": [1, 0, 1, 1, 0, 1, 1, 0, 1, 0, 1, 1, 0, 1, 1, 0], // Complex hi-hat rolls
      "OH": [0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 1], // Open hat accents
      "CP": [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0], // Sparse clap
    }
  },
  dnb: {
    key: "dnb",
    nameKey: "drumPatterns.dnb",
    description: "Drum and bass pattern",
    recommendedDrumKit: "breakbeat",
    timeSignature: "4/4",
    noteDivision: "16n",
    tempo: 175,
    patterns: {
      "BD": [1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0], // DnB kick
      "SD": [0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0], // Amen break snare
      "CH": [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1], // Fast hi-hat
      "CP": [0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 1, 0], // Syncopated clap
      "CR": [1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], // Crash on 1
    }
  },
  reggae: {
    key: "reggae",
    nameKey: "drumPatterns.reggae",
    description: "Classic reggae skank",
    recommendedDrumKit: "rock",
    timeSignature: "4/4",
    noteDivision: "8n",
    tempo: 80,
    patterns: {
      "BD": [0, 0, 1, 0, 0, 0, 1, 0], // Reggae kick on 3 and 7
      "SD": [0, 0, 0, 1, 0, 0, 0, 1], // Backbeat on 4 and 8
      "CH": [1, 1, 0, 1, 1, 1, 0, 1], // Skank pattern
      "OH": [0, 0, 1, 0, 0, 0, 1, 0], // Open hat accents
      "CP": [0, 0, 0, 0, 0, 1, 0, 0], // Occasional clap
    }
  },
  afrobeat: {
    key: "afrobeat",
    nameKey: "drumPatterns.afrobeat",
    description: "Afrobeat groove",
    recommendedDrumKit: "latin",
    timeSignature: "4/4",
    noteDivision: "16n",
    tempo: 115,
    patterns: {
      "BD": [1, 0, 0, 1, 0, 0, 1, 0, 1, 0, 0, 1, 0, 0, 1, 0], // Afrobeat kick
      "SD": [0, 0, 1, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 1, 0, 0], // Cross-stick pattern
      "CH": [1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0], // Steady 8th hi-hat
      "SH": [0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1], // Shaker 16ths
      "CB": [1, 0, 0, 0, 0, 1, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0], // Cowbell pattern
      "CP": [0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0], // Sparse clap
    }
  },
  shuffle: {
    key: "shuffle",
    nameKey: "drumPatterns.shuffle",
    description: "Blues shuffle groove",
    recommendedDrumKit: "jazz",
    timeSignature: "4/4",
    noteDivision: "8n",
    tempo: 120,
    patterns: {
      "BD": [1, 0, 0, 1, 0, 0, 1, 0], // Shuffle kick
      "SD": [0, 0, 1, 0, 0, 0, 1, 0], // Backbeat snare
      "CH": [1, 0, 1, 1, 0, 1, 1, 0], // Shuffle hi-hat pattern
      "RD": [1, 1, 0, 1, 1, 0, 1, 1], // Swing ride
      "CR": [1, 0, 0, 0, 0, 0, 0, 0], // Crash on 1
    }
  },
  progressive: {
    key: "progressive",
    nameKey: "drumPatterns.progressive",
    description: "Progressive rock pattern",
    recommendedDrumKit: "rock",
    timeSignature: "6/8",
    noteDivision: "8n",
    tempo: 130,
    patterns: {
      "BD": [1, 0, 0, 1, 0, 1], // Complex 7/8 kick (workaround for 6/8)
      "SD": [0, 0, 1, 0, 0, 0], // Irregular snare
      "CH": [1, 1, 1, 1, 1, 1], // Constant hi-hat
      "CR": [1, 0, 0, 0, 0, 0], // Crash on 1
      "T1": [0, 1, 0, 0, 1, 0], // Tom accents
      "T2": [0, 0, 0, 1, 0, 0], // Another tom
    }
  }  
};

// 輔助函數：獲取pattern
export const getDrumPattern = (key: string) => {
  return PRESET_DRUM_PATTERNS[key as keyof typeof PRESET_DRUM_PATTERNS];
};

// 獲取所有pattern列表
export const getAllDrumPatterns = () => {
  return Object.values(PRESET_DRUM_PATTERNS);
};

// 根據樂器ID映射pattern到正確的grid格式
export const applyPatternToGrid = (pattern: any, instruments: any[]) => {
  const newGrid: Record<string, any[]> = {};
  
  // 初始化所有樂器為空
  instruments.forEach(({ id }: { id: string }) => {
    newGrid[id] = Array(64).fill(null);
  });
  
  // 應用pattern到對應的樂器
  Object.entries(pattern.patterns).forEach(([patternInstrumentId, hits]) => {
    // 尋找匹配的樂器（優先完全匹配，然後按類型匹配）
    const matchedInstrument = instruments.find((inst: any) => 
      inst.id === patternInstrumentId || 
      inst.id.toLowerCase() === patternInstrumentId.toLowerCase()
    );
    
    if (matchedInstrument) {
      // 將pattern應用到對應樂器的grid中
      (hits as any[]).forEach((hit: any, index: number) => {
        if (hit && index < newGrid[matchedInstrument.id].length) {
          newGrid[matchedInstrument.id][index] = "x"; // 使用基本hit type
        }
      });
    }
  });
  
  return newGrid;
};

// 獲取pattern的小節步數
export const getPatternSteps = (pattern: any) => {
  const maxSteps = Math.max(
    ...Object.values(pattern.patterns).map((hits: any) => (hits as any[]).length)
  );
  return maxSteps;
};

// 獲取推薦的鼓組配置
export const getRecommendedDrumKit = (patternKey: string) => {
  const pattern = getDrumPattern(patternKey);
  return pattern ? pattern.recommendedDrumKit : null;
}; 
